import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Employees.css';
import loadingSpinner from './../../assets/loading.gif';
import {CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import {CreateTable} from './../ManageTable';
import axios from 'axios';
import {token, domain} from './../Security';
// icons
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SearchIcon from '@mui/icons-material/Search';

function RelationshipDisclosure({user, isHideSideMenu}) {
    var header = [
        "Name",
        "Position",
        "Site",
        "Have Personal Rel. w/ Listed Above?",
        "No. Of Relationship Disclosure",
        "",
    ]
    var accessor = [
        "fullName",
        "positionDescription",
        "locationDescription",
        "haveRelationship",
        "noOfRelatedPeople",
        "manage"
    ]

    const categories = [
        "Co-employee (staff, operators, workers)",
        "Security Officer",
        "Suppliers",
        "Subcontractors (SUBCON)",
        "Trade contractors (TRADECON)",
        "Management",
        "Owner-side representatives"
    ]

    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    // Retrieve
    const [filterData, setFilterData] = useState([]);

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5", zIndex: 100000}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);

        const res = filterData.filter(
            f => (f.fullName ?? "")
                .toLowerCase()
                .includes(lowercaseValue)
        );

        setData(res);
    };

    //variables 
    const [email, setEmail] = useState(null);
    const [isMyself, setIsMyself] = useState(true);
    const [firstName, setFirstName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [lastName, setLastName] = useState("");
    const [contactNo, setContactNo] = useState("");
    const [position, setPosition] = useState(null);
    const [location, setLocation] = useState(null);
    const [haveRelationship, setHaveRelationship] = useState(null);
    const [noOfRelatedPeople, setNoOfRelatedPeople] = useState(0)
    const [relationshipData, setRelationshipData] = useState([])
    const [formStep, setFormStep] = useState(1); // 1: Info, 2: Branching Logic
    const [isCertified, setIsCertified] = useState(false);
    const [selectedData, setSelectedData] = useState(null)

    const resetVariables = () => {
        setEmail(null);
        setIsMyself(true);
        setFirstName("");
        setMiddleName("");
        setLastName("");
        setContactNo("");
        setPosition(null);
        setLocation(null);
        setHaveRelationship(null);
        setNoOfRelatedPeople(0)
        setRelationshipData([])
        setFormStep(1)
        setIsCertified(false)
        setSelectedData(null)
    }

    const fetchData = useCallback(async () => {
        const apiUrl =  domain + "/api/RelationshipDisclosure";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, []);

    const fetchDataById = useCallback(async (_data) => {
        const apiUrl =  domain + "/api/RelationshipDisclosure";

        try {
            const response = await axios.get(`${apiUrl}/${_data.id}` , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return response.data; // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return null
        }
    }, []);

    useEffect(() => {
        fetchData()
    }, [fetchData])

    const [showAddForm, setShowAddForm] = useState(false);
    const openAddForm = () => {
        setShowAddForm(true);
    }
    const closeAddForm = () => {
        setShowAddForm(false);
        resetVariables();
    }

    const handleAdd = async () => {
        const data = {
            email: email ?? "",
            isMyself: isMyself ?? false,
            firstName: firstName ?? "",
            middleName: middleName ?? "",
            lastName: lastName ?? "",
            contactNo: contactNo ?? "",
            positionId: position?.id ?? null,
            locationId: location?.id ?? null,
            haveRelationship: haveRelationship ?? false,
            noOfRelatedPeople: parseInt(noOfRelatedPeople),
            relationshipDisclosureDetail: relationshipData ?? [],
            createdBy: user?.id ?? null
        };

        const apiUrl =  domain + "/api/RelationshipDisclosure";

        try {
            setLoading(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
            closeAddForm();
        }
    };

    const [showUpdateForm, setShowUpdateForm] = useState(false);
    const openUpdateForm = () => {
        setShowUpdateForm(true);
    }
    const closeUpdateForm = () => {
        setShowUpdateForm(false);
        resetVariables();
    }

    const editHandleClick = async (_data) => {
        setLoading(true);

        const dataById = await fetchDataById(_data)
        setSelectedData(dataById)

        setEmail(dataById?.email ?? "");
        setIsMyself(dataById?.isMyself ?? true);
        setFirstName(dataById?.firstName ?? "");
        setMiddleName(dataById?.middleName ?? "");
        setLastName(dataById?.lastName ?? "");
        setContactNo(dataById?.contactNo ?? "");
        setPosition(dataById?.position ?? null);
        setLocation(dataById?.location ?? null);
        setHaveRelationship(dataById?.haveRelationship ?? false);
        setNoOfRelatedPeople(dataById?.noOfRelatedPeople ?? 1)
        setRelationshipData(dataById?.relationshipDisclosureDetail ?? [])

        openUpdateForm()
        setLoading(false);
    }

    const handleUpdate = async () => {
        const data = {
            email: email ?? "",
            isMyself: isMyself ?? false,
            firstName: firstName ?? "",
            middleName: middleName ?? "",
            lastName: lastName ?? "",
            contactNo: contactNo ?? "",
            positionId: position?.id ?? null,
            locationId: location?.id ?? null,
            haveRelationship: haveRelationship ?? false,
            noOfRelatedPeople: parseInt(noOfRelatedPeople),
            relationshipDisclosureDetail: relationshipData ?? [],
            updatedBy: user?.id ?? null
        };

        const apiUrl =  domain + `/api/RelationshipDisclosure/update/${selectedData?.id}`;

        try {
            setLoading(true);
            await axios.post(apiUrl, data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData();
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem adding data:', error);
            setShowRequestMessage(true);
            setIsSuccess(false);
            const errorMessage = JSON.parse(error.response.request.responseText).message;
            setRequestMessage(errorMessage);
        } finally {
            setLoading(false);
            closeUpdateForm();
        }
    };

    const [showViewForm, setShowViewForm] = useState(false);
    const openViewForm = () => {
        setShowViewForm(true);
    }
    const closeViewForm = () => {
        setShowViewForm(false);
        resetVariables();
    }

    const viewHandleClick = async (_data) => {
        setLoading(true);

        const dataById = await fetchDataById(_data)
        setSelectedData(dataById)

        setEmail(dataById?.email ?? "");
        setIsMyself(dataById?.isMyself ?? true);
        setFirstName(dataById?.firstName ?? "");
        setMiddleName(dataById?.middleName ?? "");
        setLastName(dataById?.lastName ?? "");
        setContactNo(dataById?.contactNo ?? "");
        setPosition(dataById?.position ?? null);
        setLocation(dataById?.location ?? null);
        setHaveRelationship(dataById?.haveRelationship ?? false);
        setNoOfRelatedPeople(dataById?.noOfRelatedPeople ?? 1)
        setRelationshipData(dataById?.relationshipDisclosureDetail ?? [])

        openViewForm()
        setLoading(false);
    }

    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"Relationship Disclosure"}</span>
                            </div>
                            <div className='row' style={{justifyContent: "space-between", alignItems: "center"}}>
                                <h3>Relationship Disclosure</h3>
                            </div>
                        </div>
                        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg shadow-sm mt-4">
                            <div className="flex items-center mb-2">
                                <svg className="w-5 h-5 text-blue-500 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                                </svg>
                                <h4 className="text-sm font-bold text-blue-900 uppercase tracking-wider">Disclosure Categories</h4>
                            </div>
                            <p className="text-sm text-blue-800 mb-3 italic">List of the following entities:</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-2 gap-x-4">
                                {categories.map((item, index) => (
                                    <div key={index} className="flex items-center text-sm text-blue-700">
                                        <span className="mr-2 text-blue-400 font-bold">•</span>
                                        {item}
                                    </div>
                                ))}
                            </div>
                        </div>
                        {/* --- CATEGORY NOTE SECTION END --- */}
                        <div className="employeesTab-body mt-1">
                            <div className="body-top row justify-between">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e)=>handleFilter(e.target.value), 
                                                                    "Search by name", 
                                                                    SearchIcon)}
                                </div>
                                <button className='bg-green-500 hover:bg-green-600 text-white rounded-sm border-none p-3 cursor-pointer'
                                    onClick={openAddForm}
                                >
                                    Add Disclosure
                                </button>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={data}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    viewHandleClick={viewHandleClick}
                                    // deleteHandleClick={openDeleteForm}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                                {data.length > 0 ? (
                                    <div></div>
                                )
                                :
                                (
                                    <div>
                                    {loading ? (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                            <img src={loadingSpinner} alt="Loading..." />
                                        </div>
                                    ) : (
                                            <div> {/*<p>No records to display</p>*/}</div>
                                        )
                                    }
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- RELATIONSHIP DISCLOSURE MODAL --- */}
            {showAddForm && (
                <DisclosureForm 
                    isOpen={showAddForm} onClose={closeAddForm}
                    email={email} setEmail={setEmail}
                    isMyself={isMyself} setIsMyself={setIsMyself}
                    firstName={firstName} setFirstName={setFirstName}
                    middleName={middleName} setMiddleName={setMiddleName}
                    lastName={lastName} setLastName={setLastName}
                    contactNo={contactNo} setContactNo={setContactNo}
                    position={position} setPosition={setPosition}
                    location={location} setLocation={setLocation}
                    haveRelationship={haveRelationship} setHaveRelationship={setHaveRelationship}
                    noOfRelatedPeople={noOfRelatedPeople} setNoOfRelatedPeople={setNoOfRelatedPeople}
                    relationshipData={relationshipData} setRelationshipData={setRelationshipData}
                    formStep={formStep} setFormStep={setFormStep}
                    isCertified={isCertified} setIsCertified={setIsCertified}
                    handleSubmit={handleAdd}
                />
            )}

            {/* --- RELATIONSHIP DISCLOSURE MODAL --- */}
            {showUpdateForm && (
                <DisclosureForm 
                    isOpen={showUpdateForm} onClose={closeUpdateForm}
                    email={email} setEmail={setEmail}
                    isMyself={isMyself} setIsMyself={setIsMyself}
                    firstName={firstName} setFirstName={setFirstName}
                    middleName={middleName} setMiddleName={setMiddleName}
                    lastName={lastName} setLastName={setLastName}
                    contactNo={contactNo} setContactNo={setContactNo}
                    position={position} setPosition={setPosition}
                    location={location} setLocation={setLocation}
                    haveRelationship={haveRelationship} setHaveRelationship={setHaveRelationship}
                    noOfRelatedPeople={noOfRelatedPeople} setNoOfRelatedPeople={setNoOfRelatedPeople}
                    relationshipData={relationshipData} setRelationshipData={setRelationshipData}
                    formStep={formStep} setFormStep={setFormStep}
                    isCertified={isCertified} setIsCertified={setIsCertified}
                    handleSubmit={handleUpdate}
                />
            )}

            <DisclosureViewModal 
                isOpen={showViewForm} 
                onClose={closeViewForm} 
                email={email}
                isMyself={isMyself}
                firstName={firstName}
                middleName={middleName}
                lastName={lastName}
                contactNo={contactNo}
                position={position} // This should be the object from your EF Join
                location={location} // This should be the object from your EF Join
                haveRelationship={haveRelationship}
                noOfRelatedPeople={noOfRelatedPeople}
                relationshipData={relationshipData}
            />

            <GenerateMessage form={showRequestMessage}
                message={isSuccess ? "Request Success!" : requestMessage}
                isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loading ? (
                <div style={{ position:"fixed", top:"50%", left:"50%", transform:"translate(-50%, -50%)"}}>
                    <img src={loadingSpinner} alt="Loading..." />
                </div>
            ) : (
                    <></>
                )
            }
        </div>
    )
}

const DisclosureForm = ({
    isOpen, onClose,
    email, setEmail,
    isMyself, setIsMyself,
    firstName, setFirstName,
    middleName, setMiddleName,
    lastName, setLastName,
    contactNo, setContactNo,
    position, setPosition,
    location, setLocation,
    haveRelationship, setHaveRelationship,
    noOfRelatedPeople, setNoOfRelatedPeople,
    relationshipData, setRelationshipData,
    formStep, setFormStep,
    isCertified, setIsCertified,
    handleSubmit,
}) => {
    const handleRelationshipChange = (index, field, value) => {
        const updatedData = [...relationshipData];
        if (!updatedData[index]) updatedData[index] = {};
        updatedData[index][field] = value;
        setRelationshipData(updatedData);
    };

    const handleNoOfPeopleChange = (num) => {
        // 1. Update the count state
        setNoOfRelatedPeople(num);

        // 2. Synchronize the relationship data array
        setRelationshipData((prevData) => {
            // If the new number is smaller, slice(0, num) removes the extra items.
            // If the new number is larger, it returns the current array as is.
            return prevData.slice(0, num);
        });
    };

    const handleProceed = () => {
        if (formStep === 1 && 
            (haveRelationship === null
                || !email
                || !firstName
                || !lastName
                || !position
                || !location
            )
        ) {
            return alert("Please input all required fields.");
        }
                            
        // Navigation logic
        if (haveRelationship === false) {
            if (formStep === 1) {
                setFormStep(2);
            }
            else if (isCertified) { 
                handleSubmit();
                onClose();
            }
        } else {
            if (formStep === 3 && haveRelationship === true) {
            
                // Loop through each person the user said they have a relationship with
                for (let i = 0; i < noOfRelatedPeople; i++) {
                    const person = relationshipData[i];

                    // Check if the object exists and if all keys have values
                    const isComplete = 
                        person?.relationship && 
                        person?.type && 
                        person?.fullName?.trim() && 
                        person?.company?.trim() && 
                        person?.role?.trim();

                    if (!isComplete) {
                        return alert(`Please fill up all info for Relationship Disclosure #${i + 1}`);
                    }
                }

                // If loop finishes, all data is valid
                setFormStep(prev => prev + 1);
            } 
            else if (formStep < 4) {
                // General step increment for steps other than 3
                setFormStep(prev => prev + 1);
            }
            else if (isCertified) { 
                handleSubmit(); 
                onClose();
            }
        }
    }

    return (
        isOpen &&
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4" style={{ zIndex: "10000" }}>
            <div className="bg-white w-full max-w-2xl max-h-[90vh] flex flex-col rounded-xl shadow-2xl border border-gray-200 overflow-hidden">
                
                {/* FIXED HEADER */}
                <div className="bg-[#668fca] p-6 text-white shrink-0">
                    <div className="flex justify-between items-start">
                        <div>
                            <h2 className="text-2xl font-bold uppercase tracking-tight text-white">Relationship Disclosure Form</h2>
                            <span className="text-xs bg-blue-800 px-2 py-1 rounded mt-1 inline-block">
                                {haveRelationship === false ? `Step ${formStep} of 2` : `Step ${formStep} of 4`}
                            </span>
                        </div>
                        <button onClick={onClose} className="cursor-pointer border-none bg-transparent text-white hover:text-gray-200 text-2xl font-bold leading-none">&times;</button>
                    </div>
                </div>

                {/* SCROLLABLE BODY */}
                <div className="p-8 overflow-y-auto flex-1">
                    
                    {/* --- STEP 1: BASIC INFO --- */}
                    {formStep === 1 && (
                        <form className="space-y-6">
                            <div className="bg-gray-50 p-4 border border-gray-200 rounded text-xs text-gray-600 italic">
                                All information provided shall be treated with strict confidentiality and used solely for internal assessment and compliance purposes.
                            </div>
                            {/* Email */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Email <span className="text-red-500">*</span></label>
                                <input type="email" required className="w-full p-2 placeholder-gray-400 outline-none bg-transparent border-none" style={{borderBottom: "1px solid gray"}} placeholder="yourname@email.com" value={email || ""} onChange={(e) => setEmail(e.target.value)} />
                            </div>
                            {/* Myself/Someone Else */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-3">Who are you filling up this form for? <span className="text-red-500">*</span></label>
                                <div className="flex gap-6">
                                    <label className="flex items-center cursor-pointer"><input type="radio" checked={isMyself} onChange={() => setIsMyself(true)} className="w-4 h-4 text-blue-600" /><span className="ml-2 text-sm text-gray-700">Myself</span></label>
                                    <label className="flex items-center cursor-pointer"><input type="radio" checked={!isMyself} onChange={() => setIsMyself(false)} className="w-4 h-4 text-blue-600" /><span className="ml-2 text-sm text-gray-700">Someone Else</span></label>
                                </div>
                            </div>
                            {/* Names */}
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 uppercase">First Name</label>
                                    <input type="text" placeholder="JUAN" className="w-full p-2 outline-none uppercase border-none" style={{borderBottom: "1px solid gray"}} value={firstName} onChange={(e) => setFirstName(e.target.value.toUpperCase())} />
                                </div>
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 uppercase">Middle Name</label>
                                    <input type="text" placeholder="DELA" className="w-full p-2 outline-none uppercase border-none" style={{borderBottom: "1px solid gray", borderLeft: "1px solid gray"}} value={middleName} onChange={(e) => setMiddleName(e.target.value.toUpperCase())} />
                                </div>
                                <div>
                                    <label className="block text-xs font-bold text-gray-500 uppercase">Last Name</label>
                                    <input type="text" placeholder="CRUZ" className="w-full p-2 outline-none uppercase border-none" style={{borderBottom: "1px solid gray", borderLeft: "1px solid gray"}} value={lastName} onChange={(e) => setLastName(e.target.value.toUpperCase())} />
                                </div>
                            </div>
                            {/* Position/Location */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-1">Contact Number</label>
                                    <input type="text" placeholder="09xxxxxxxx" className="w-full p-2 border-none outline-none" style={{borderBottom: "1px solid gray"}} value={contactNo} onChange={(e) => setContactNo(e.target.value)} />
                                </div>
                                <div>
                                    <label className="block text-sm font-bold text-gray-700 mb-1">Position <span className="text-red-500">*</span></label>
                                    <PositionSelect data={position} setData={setPosition} isEditable={true}/>
                                </div>
                            </div>
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Project / Site <span className="text-red-500">*</span></label>
                                <LocationSelect data={location} setData={setLocation} isEditable={true}/>
                            </div>
                            {/* Relationship Question */}
                            <div className="bg-blue-50 p-4 rounded-lg border border-blue-100">
                                <label className="block text-sm font-bold text-blue-900 mb-2">Do you have any personal or familial relationship with any of the following? <span className="text-red-500">*</span></label>
                                <div className="flex gap-6 mt-4">
                                    <label className="flex items-center cursor-pointer text-sm font-medium">
                                        <input type="radio" name="rel" checked={haveRelationship === true} onChange={() => setHaveRelationship(true)} className="w-4 h-4" />
                                        <span className="ml-2">Yes, I do</span>
                                    </label>
                                    <label className="flex items-center cursor-pointer text-sm font-medium">
                                        <input type="radio" name="rel" checked={haveRelationship === false} onChange={() => setHaveRelationship(false)} className="w-4 h-4" />
                                        <span className="ml-2">No, I don't</span>
                                    </label>
                                </div>
                            </div>
                        </form>
                    )}

                    {/* --- STEP 2: IF TRUE (SELECT COUNT) --- */}
                    {formStep === 2 && haveRelationship === true && (
                        <div className="flex flex-wrap justify-center gap-4">
                            {[1, 2, 3, 4, 5].map((num) => (
                                <button
                                    key={num}
                                    type="button"
                                    // CHANGE THIS: Pass 'num', not 'e'
                                    onClick={() => handleNoOfPeopleChange(num)} 
                                    className={`cursor-pointer w-16 h-16 rounded-full border-2 font-bold text-xl transition-all 
                                        ${noOfRelatedPeople === num 
                                            ? "bg-blue-600 border-blue-600 text-white scale-110 shadow-lg" 
                                            : "bg-white border-gray-300 text-gray-600 hover:border-blue-400"
                                        }`}
                                >
                                    {num}
                                </button>
                            ))}
                        </div>
                    )}

                    {/* --- STEP 3: IF TRUE (DETAILS PER PERSON) --- */}
                    {formStep === 3 && haveRelationship === true && (
                        <div className="space-y-12 animate-in fade-in slide-in-from-bottom-4 duration-500">
                            {Array.from({ length: noOfRelatedPeople }).map((_, i) => (
                                <div key={i} className="border-l-4 border-[#668fca] pl-6 py-2 space-y-6">
                                    <h4 className="text-blue-800 font-black uppercase tracking-widest text-sm">
                                        {i === 0 ? "1ST" : i === 1 ? "2ND" : i === 2 ? "3RD" : i === 3 ? "4TH" : "5TH"} — RELATIONSHIP DISCLOSURE DETAILS
                                    </h4>

                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Relationship Disclosure Detail <span className="text-red-500">*</span></label>
                                        <RelationshipDisclosureSelect data={relationshipData[i]?.relationship} setData={(val) => handleRelationshipChange(i, 'relationship', val)}  isEditable={true}/>
                                    </div>

                                    <div>
                                        <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Type of Relationship <span className="text-red-500">*</span></label>
                                        <TypeOfRelationshipSelect data={relationshipData[i]?.type} setData={(val) => handleRelationshipChange(i, 'type', val)}  isEditable={true}/>
                                    </div>
                                    
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                        <div>
                                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Full Name of Related Person <span className="text-red-500">*</span></label>
                                            <input 
                                                type="text" 
                                                placeholder="FULL NAME"
                                                className="w-full p-2 outline-none border-none uppercase" style={{borderBottom: "1px solid gray"}}
                                                onChange={(e) => handleRelationshipChange(i, 'fullName', e.target.value)}
                                                value={relationshipData[i]?.fullName || ""}
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Name of Company <span className="text-red-500">*</span></label>
                                            <input 
                                                type="text" 
                                                placeholder="Sample: DLBI"
                                                className="w-full p-2 outline-none border-none" style={{borderBottom: "1px solid gray"}}
                                                onChange={(e) => handleRelationshipChange(i, 'company', e.target.value)}
                                                value={relationshipData[i]?.company || ""}
                                            />
                                        </div>
                                        <div>
                                            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Position / Role <span className="text-red-500">*</span></label>
                                            <input 
                                                type="text" 
                                                className="w-full p-2 outline-none border-none" style={{borderBottom: "1px solid gray"}}
                                                onChange={(e) => handleRelationshipChange(i, 'role', e.target.value)}
                                                value={relationshipData[i]?.role || ""}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* --- FINAL STEP: CERTIFICATION (Used for 'No' step 2 or 'Yes' step 4) --- */}
                    {((formStep === 2 && haveRelationship === false) || (formStep === 4 && haveRelationship === true)) && (
                        <div className="space-y-6 animate-in fade-in duration-500">
                            <div className="bg-gray-50 border-l-4 border-blue-500 p-6 space-y-4 text-gray-700 text-sm leading-relaxed">
                                <p>I hereby certify that all information provided in this Relationship Disclosure Form is true, complete, and correct to the best of my knowledge.</p>
                                <p>I understand that any false statement, misrepresentation, or failure to disclose relevant information may be grounds for disciplinary action in accordance with company policies and applicable laws.</p>
                                <p>I further undertake to immediately inform Don Lee Builders Inc. of any change in the information disclosed herein.</p>
                                <p>By submitting this form, I voluntarily give my consent to the collection, processing, and use of the above information for internal assessment, compliance, and record-keeping purposes, in accordance with company policies.</p>
                            </div>
                            <label className="flex items-start gap-3 p-4 bg-blue-50 rounded-lg cursor-pointer border border-blue-200">
                                <input type="checkbox" checked={isCertified} onChange={(e) => setIsCertified(e.target.checked)} className="mt-1 w-5 h-5" />
                                <span className="text-sm font-bold text-blue-900">I confirm and agree to the certification and consent stated above.</span>
                            </label>
                        </div>
                    )}
                </div>

                {/* FIXED FOOTER */}
                <div className="p-6 border-t border-gray-100 flex justify-between items-center bg-gray-50">
                    <button type="button" onClick={formStep === 1 ? onClose : () => setFormStep(prev => prev - 1)} className="cursor-pointer border-none px-6 py-2 text-gray-600 font-bold hover:underline uppercase">
                        {formStep === 1 ? "CANCEL" : "BACK"}
                    </button>

                    <button 
                        type="button"
                        onClick={handleProceed}
                        disabled={((formStep === 2 && haveRelationship === false) || (formStep === 4)) && !isCertified}
                        className={`cursor-pointer border-none px-10 py-2 text-white font-bold rounded shadow-lg transition-all 
                            ${(((formStep === 2 && haveRelationship === false) || (formStep === 4)) && !isCertified) ? "bg-gray-300" : "bg-gray-500 hover:bg-gray-600"}`}
                    >
                        {((formStep === 2 && haveRelationship === false) || (formStep === 4)) ? "SUBMIT DISCLOSURE" : "NEXT"}
                    </button>
                </div>
            </div>
        </div>
    )
}
const DisclosureViewModal = ({
    isOpen,
    onClose,
    email,
    isMyself,
    firstName,
    middleName,
    lastName,
    contactNo,
    position, // Object with Description
    location, // Object with Description
    haveRelationship,
    noOfRelatedPeople,
    relationshipData,
}) => {
    if (!isOpen) return null;

    // Helper to display labels and values
    const DataField = ({ label, value }) => (
        <div className="py-2">
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">{label}</p>
            <p className="text-sm font-medium text-gray-800 uppercase">{value || "—"}</p>
        </div>
    );

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4 z-[10000]">
            <div className="bg-white w-full max-w-3xl max-h-[90vh] flex flex-col rounded-lg shadow-2xl overflow-hidden border border-gray-200">
                
                {/* HEADER / BANNER */}
                <div className="bg-[#668fca] p-8 text-white shrink-0 relative">
                    <div className="absolute top-4 right-4">
                        <button onClick={onClose} className="cursor-pointer border-none bg-transparent text-white hover:text-gray-200 text-2xl font-bold leading-none">&times;</button>
                    </div>
                    <h2 className="text-2xl font-black uppercase tracking-tighter">Relationship Disclosure</h2>
                    <p className="text-blue-100 text-xs font-bold uppercase tracking-widest mt-1">Don Lee Builders Inc. — Compliance Document</p>
                </div>

                {/* DOCUMENT BODY */}
                <div className="p-10 overflow-y-auto flex-1 bg-white">
                    
                    {/* SECTION 1: DISCLOSER INFORMATION */}
                    <section className="mb-10">
                        <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-4">
                            I. Discloser Information
                        </h3>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-4">
                            <DataField label="Full Name" value={`${lastName}, ${firstName} ${middleName || ""}`} />
                            <DataField label="Filling for" value={isMyself ? "Self" : "Someone Else"} />
                            <DataField label="Email Address" value={email} />
                            <DataField label="Contact Number" value={contactNo} />
                            <DataField label="Position" value={position?.Description || position?.description} />
                            <DataField label="Project / Site" value={location?.Description || location?.description} />
                        </div>
                    </section>

                    {/* SECTION 2: STATUS */}
                    <section className="mb-10">
                        <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-4">
                            II. Disclosure Status
                        </h3>
                        <div className={`inline-block px-4 py-2 rounded font-bold text-sm ${haveRelationship ? "bg-amber-50 text-amber-700 border border-amber-200" : "bg-green-50 text-green-700 border border-green-200"}`}>
                            {haveRelationship 
                                ? `YES — I have relationship(s) to disclose (${noOfRelatedPeople} person/s)` 
                                : "NO — I have no personal or familial relationships to disclose"
                            }
                        </div>
                    </section>

                    {/* SECTION 3: RELATED PEOPLE (Only if true) */}
                    {haveRelationship && relationshipData && relationshipData.length > 0 && (
                        <section className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                            <h3 className="text-blue-800 font-black text-xs uppercase tracking-[0.2em] border-b border-gray-100 pb-2 mb-6">
                                III. Details of Related Persons
                            </h3>
                            <div className="space-y-8">
                                {relationshipData.map((person, i) => (
                                    <div key={i} className="bg-gray-50 p-6 rounded-lg border border-gray-200 relative">
                                        <div className="absolute -top-3 left-4 bg-[#668fca] text-white px-3 py-1 text-[10px] font-black rounded shadow-sm">
                                            PERSON #{i + 1}
                                        </div>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-2">
                                            <div className="md:col-span-2">
                                                <DataField label="Full Name of Related Person" value={person.fullName} />
                                            </div>
                                            <DataField label="Relationship Disclosure Detail" value={person.relationship} />
                                            <DataField label="Type of Relationship" value={person.type} />
                                            <DataField label="Name of Company" value={person.company} />
                                            <DataField label="Position / Role" value={person.role} />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </section>
                    )}

                    {/* FOOTER CERTIFICATION TEXT */}
                    <div className="mt-12 pt-8 border-t border-gray-100 text-[11px] text-gray-400 italic text-justify leading-relaxed">
                        This document serves as a formal declaration. The discloser has certified that all information provided is true, complete, and correct. This data is protected under the company's privacy policy and data protection regulations.
                    </div>
                </div>

                {/* MODAL FOOTER */}
                <div className="p-6 bg-gray-50 border-t border-gray-100 flex justify-end">
                    <button 
                        onClick={onClose}
                        className="cursor-pointer bg-gray-800 hover:bg-black text-white px-8 py-2 rounded text-xs font-black tracking-widest uppercase transition-all shadow-md"
                    >
                        Close Document
                    </button>
                </div>
            </div>
        </div>
    );
};

const PositionSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Position/active` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data?.id || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    {_data.map(({ id, description }) => (
                    <option key={id} value={id} className='text-gray-700'>
                        {`${description}`}
                    </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
const LocationSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);
    const [_data, _setData] = useState([]);

    const handleSelectChange = (event) => {
        setIsSelected(true);

        const id_value = event.target.value;
        const selectedData = _data.find((temp) => temp.id.toString() === id_value.toString());

        if (selectedData) {
            setData(selectedData);
        } else {
            setData(null);
        }
    };

    const fetchData = useCallback(async () => {
        try {
            const response = await axios.get(`${domain}/api/Location/active` , {
                headers: { 'Content-Type': 'application/json'}
            })
            
            _setData(response.data)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        fetchData();
        setIsSelected(!!data && data !== 0);
    }, [data, fetchData]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data?.id || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    {_data.map(({ id, description }) => (
                    <option key={id} value={id} className='text-gray-700'>
                        {`${description}`}
                    </option>
                    ))}
                </select>
            </div>
        </div>
    );
};
const TypeOfRelationshipSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setData(event.target.value);
    };

    useEffect(() => {
        setIsSelected(!!data && data !== 0);
    }, [data]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    <option value={`Romantic relationship with a fellow employee`} className='text-gray-700'>
                        {`Romantic relationship with a fellow employee`}
                    </option>
                    <option value={`Related by blood/marriage (up to 2nd degree) with a fellow employee`} className='text-gray-700'>
                        {`Related by blood/marriage (up to 2nd degree) with a fellow employee`}
                    </option>
                    <option value={`Romantic relationship with employee/representative of trade contractor or subcontractor`} className='text-gray-700'>
                        {`Romantic relationship with employee/representative of trade contractor or subcontractor`}
                    </option>
                    <option value={`Related by blood/marrigae (up to 2nd degree) with employee/representative of trade contractor or subcontractor`} className='text-gray-700'>
                        {`Related by blood/marrigae (up to 2nd degree) with employee/representative of trade contractor or subcontractor`}
                    </option>
                </select>
            </div>
        </div>
    );
};
const RelationshipDisclosureSelect = ({data, setData, isEditable}) => {
    const [isSelected, setIsSelected] = useState(false);

    const handleSelectChange = (event) => {
        setIsSelected(true);
        setData(event.target.value);
    };

    useEffect(() => {
        setIsSelected(!!data && data !== 0);
    }, [data]);

    return (
        <div className="flex flex-col gap-1">
            <div>
                <select
                    value={data || ""}
                    onChange={handleSelectChange}
                    disabled={!isEditable}
                    className={`w-full p-[7px] focus:border-blue-600 outline-none border-none
                        ${isSelected ? "text-gray-700" : "text-gray-700"}
                    `}
                    style={{color: "gray", borderBottom: "1px solid gray"}}
                >
                    <option value=""> Choose type </option>
                    <option value={`Company employee`} className='text-gray-700'>
                        {`Company employee`}
                    </option>
                    <option value={`Security Officer`} className='text-gray-700'>
                        {`Security Officer`}
                    </option>
                    <option value={`Supplier (Employee/Owner)`} className='text-gray-700'>
                        {`Supplier (Employee/Owner)`}
                    </option>
                    <option value={`Trade Contractor (Employee/Owner)`} className='text-gray-700'>
                        {`Trade Contractor (Employee/Owner)`}
                    </option>
                    <option value={`Management (Employee)`} className='text-gray-700'>
                        {`Management (Employee)`}
                    </option>
                    <option value={`Owner-side representative (Employee)`} className='text-gray-700'>
                        {`Owner-side representative (Employee)`}
                    </option>
                </select>
            </div>
        </div>
    );
};
export default RelationshipDisclosure
